// src/reducer/sidebarReducer.js
// Robust sidebar reducer: handles toggle/open/close. Does NOT throw on unknown actions.

const sidebarReducer = (state, action) => {
  // Useful debug: uncomment to log every dispatch while debugging
  // console.log("sidebarReducer action:", action);

  // protect against undefined action
  const type = action && action.type;

  switch (type) {
    case "TOGGLE_SIDEBAR":
      return { ...state, isSidebarOpen: !state.isSidebarOpen };
    case "OPEN_SIDEBAR":
      return { ...state, isSidebarOpen: true };
    case "CLOSE_SIDEBAR":
      return { ...state, isSidebarOpen: false };
    default:
      // IMPORTANT: do not throw here — return current state so the app stays alive
      return state;
  }
};

export default sidebarReducer;
